// services/v3/writeGuard.ts — the single gate for every V3 write (SPEC §2)
import { readV3Config } from './config'

export function isReadonly(): boolean {
  try {
    return readV3Config().writeMode !== 'live'
  } catch {
    // no Nuxt context (tests / early boot): fail safe
    return true
  }
}

export function assertWriteAllowed(op: string): void {
  if (isReadonly()) throw new Error('[readonly] write blocked: ' + op)
}
